export default __webpack_public_path__ + "static/media/individual.ea2dda15.svg";